/**
 * @export
 * @class Applications
 */
import * as imagesLoaded from 'imagesloaded';
import * as Packery from 'packery';

import { get } from '../../helpers/utilities';

import { Gallery } from './gallery';
import { LoadMore } from './load-more';

export class SingleApplication {
    public static id = 'single-application';


    /**
     * Initialises a new instance of Applications
     */
    constructor() {
        this.pagination();
        this.popups();
    }


    /**
     * Initialises the pagination for this page.
     * 
     * @private
     * @returns voids
     */
    private pagination(): void {
        const container = get('#js-application') as Element;
        const gridElem = get('#js-application__grid') as Element;
        if(container && gridElem) {

            // @ts-ignore
            const grid = new Packery(gridElem);
            imagesLoaded(gridElem).on('progress', () => {
                grid.layout();
            });

            new LoadMore(container, grid);
        }
    }


    /**
     * Initiates our gallery popups
     * 
     * @private
     * @returns void
     */
    private popups(): void {
        new Gallery();
    }
}
